/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/10
 * Time: 9:37
 * Desc: 网点管理-网点信息-商品黑白名单
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';

@Component
export default class GoodsBlackList extends Vue {
  /* 数据 */

  /**
   * 商品黑白名单
   * @type {ItemObject}
   * 这里得有默认数据，否则渲染会报错
   */
  public goodsBlackConfig: ItemObject = {
    ProductHide: { desc: {} }, // 商品黑名单
    ProductShow: { desc: {} }, // 商品白名单
    QikanAddHide: { desc: {} }, // 禁止以下人员发布期刊
    ActWinHide: { desc: {} }, // 活动中签黑名单
    ActAddHide: { desc: {} }, // 禁止以下人员发布活动
  };

  /* 方法 */

  /**
   * 获取黑白名单
   * @return null
   */
  public getSiteInfo(): void {
    const queryParams = {
      siteId: Number.parseInt(this.$route.params.siteId),
      moduleType: 2,
    };
    IPSService.siteInfo({ queryParams })
      .then((res) => {
        if (res && res.list) {
          const temObj = {};
          res.list.forEach((item) => {
            temObj[item.filedType] = item;
          });
          this.goodsBlackConfig = temObj;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /**
   * 格式化字符串
   * @param {string} str
   * @return {string}
   */
  public trim(str: string): string {
    str = str.replace(/，/gi, ','); // 去除中文逗号
    str = str.replace(/[\n\r]/g, ''); // 去除换行
    const strList = []; // 去除两端空格
    str.split(',').forEach((item) => {
      if (item) { strList.push(item.replace(/(^\s*)|(\s*$)/g, '')); }
    });
    return strList.join();
  }

  /**
   * 提交黑名单
   * @return null
   */
  public onSubmitBlackListData(): void {
    // 格式化数据,去掉空格和中文逗号
    this.goodsBlackConfig.ProductHide.desc.productCodes = this.trim(this.goodsBlackConfig.ProductHide.desc.productCodes);
    this.goodsBlackConfig.ProductShow.desc.productCodes = this.trim(this.goodsBlackConfig.ProductShow.desc.productCodes);
    this.goodsBlackConfig.ActWinHide.desc.mobiles = this.trim(this.goodsBlackConfig.ActWinHide.desc.mobiles);
    this.goodsBlackConfig.ActAddHide.desc.mobiles = this.trim(this.goodsBlackConfig.ActAddHide.desc.mobiles);
    this.goodsBlackConfig.QikanAddHide.desc.mobiles = this.trim(this.goodsBlackConfig.QikanAddHide.desc.mobiles);
    // 判断黑白名单是否有重叠数据
    const existList = []; // 黑名单中存在的数据
    const ProductBlackList = this.goodsBlackConfig.ProductHide.desc.productCodes.split(','); // 黑名单
    const ProductWhiteList = this.goodsBlackConfig.ProductShow.desc.productCodes.split(','); // 白名单
    if (ProductBlackList.length > 0 && ProductWhiteList.length > 0) {
      ProductWhiteList.forEach((wItem) => {
        ProductBlackList.forEach((bItem) => {
          if (wItem === bItem) { existList.push(bItem); }
        });
      });
      // split 空字符串会让数组中有空项
      if (existList.length > 0 && existList[0]) {
        this.$message({
          showClose: true,
          duration: 3000,
          message: `商品 ${existList.join(',')} 在黑名单已存在`,
          type: 'error',
        });
        return;
      }
    }
    // 组装参数
    const tempList = [];
    for (const item in this.goodsBlackConfig) {
      tempList.push(this.goodsBlackConfig[item]);
    }
    const postParams = {
      siteId: this.$route.params.siteId,
      list: tempList,
      moduleType: 2,
    };
    IPSService.saveSiteEdit({ postParams }).then((res) => {
      if (res) { this.$message.success('保存成功'); }
    });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getSiteInfo();
  }
}
